export default __webpack_public_path__ + "static/media/skillpaca_logo_full_lockup.aebc4e5d.svg";